// Token cost constants (display only - no real payment)
export const COST_UNLOCK_SPICY_IMAGE = 5;
export const COST_UNLOCK_SPICY_VIDEO = 15;
export const COST_UNLOCK_PREMIUM_PROFILE = 50;

// Initial token count for new users
export const INITIAL_TOKENS = 20;

// Responsive breakpoint
export const DESKTOP_BREAKPOINT = 900;

